import { memo, FC } from 'react';
import { BKJButton } from '@bookjane2/bookjane-design-library';
import {
  MainNavigationHeader,
  NavLogoWrapper,
} from 'components/BKJMainNavigation/BKJMainNavigation.styled';
import { NavMenuIcon } from 'components/BKJMainNavigation/src/NavMenuIcon';
import { deepEquals } from 'utils/deepEquals';
import { INavHeaderProps } from 'components/BKJMainNavigation/src/NavHeader.types';
import { WhiteLabelLogo } from 'components/WhiteLabelLogo';

const Component: FC<INavHeaderProps> = ({ onToggle, isOpen, menuIcon, ariaLabel }) => {
  return (
    <MainNavigationHeader>
      <BKJButton
        variant="NoStyles"
        type="button"
        aria-label={ariaLabel}
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        <NavMenuIcon iconName={menuIcon} color="White" />
      </BKJButton>
      <NavLogoWrapper $isOpen={isOpen}>
        <WhiteLabelLogo />
      </NavLogoWrapper>
    </MainNavigationHeader>
  );
};

export const WebNavHeader = memo(Component, deepEquals);
